import { CreateSiteCommand } from './create-site-command';
import { CreateCustomerCommand } from './create-customer-command';
import { CreateContractCommand } from './create-contract-command';
import { CreateQuoteWebConsoleCommand } from './create-quote-web-console-command';
import { CreateItemWebConsoleCommand } from './create-item-web-console-command';
import { CreateContractContactCommand } from './create-contract-contact-command';
import { CreateScaffoldWebConsoleCommand } from './create-scaffold-web-console-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ImportData {
  CreateSiteCommand: CreateSiteCommand;
  CreateCustomerCommand: CreateCustomerCommand;
  CreateContractCommand: CreateContractCommand;
  CreateQuoteCommand: CreateQuoteWebConsoleCommand;
  CreateItemCommands: CreateItemWebConsoleCommand[];
  CreateContractContactCommands: CreateContractContactCommand[];
  CreateScaffoldCommands: CreateScaffoldWebConsoleCommand[];
}


